export function isVisibleOnNavBar(link, userRole) {
  if (!link) return false;
  const granted = (userRole?.links ?? []).some(
    (entry) => entry.link === link.linkId && Number(entry.accessRight ?? 0) > 0
  );
  if (!granted) return false;
  return link.showOnNavBar === true;
}
